<template>
  <SidebarComponent /> <!-- Aggiungi il componente sidebar qui -->
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">

        <!-- Titolo e Bottone per Creare un Nuovo Utente -->
        <div class="titolo-card">
          <h1>Elenco Utenti</h1>
        </div>
        
        <div class="loader" v-if="isLoading">
          <h4>CREAZIONE  IN CORSO</h4>
        </div>

        <div class="search-container staff-users-search staff-users-toolbar">
          <div
            class="staff-users-toolbar__search-grid"
            role="search"
            aria-label="Ricerca utenti"
            :aria-busy="isLoading2"
          >
            <div class="search-field staff-users-toolbar__field staff-users-toolbar__email">
              <label for="staff-users-search-email">Email</label>
              <input
                id="staff-users-search-email"
                type="text"
                inputmode="email"
                autocomplete="off"
                v-model="searchEmail"
                placeholder="nome@esempio.it"
                class="search-bar"
                @keyup.enter="handleSearch"
              >
            </div>
            <div class="search-field staff-users-toolbar__field">
              <label for="staff-users-search-surname">Cognome</label>
              <input
                id="staff-users-search-surname"
                type="text"
                autocomplete="off"
                v-model="searchSurname"
                placeholder="Es. Rossi"
                class="search-bar"
                @keyup.enter="handleSearch"
              >
            </div>
            <div class="search-field staff-users-toolbar__field">
              <label for="staff-users-search-phone">Telefono</label>
              <input
                id="staff-users-search-phone"
                type="text"
                inputmode="tel"
                autocomplete="off"
                v-model="searchPhone"
                placeholder="3331234567"
                class="search-bar"
                @keyup.enter="handleSearch"
              >
            </div>
            <button
              type="button"
              @click="handleSearch"
              class="create-user-button staff-button-neutral staff-users-toolbar__search-button"
            >
              <span class="material-icons" aria-hidden="true">search</span>
              <span>Cerca</span>
            </button>
            <span v-if="isLoading2" class="staff-users-toolbar__status" role="status">
              Ricerca in corso…
            </span>
          </div>

          <div class="staff-users-toolbar__actions">
            <button
              type="button"
              @click="openCreateUserModal"
              class="create-user-button staff-button-positive staff-users-toolbar__create"
            >
              <span class="material-icons" aria-hidden="true">add_circle_outline</span>
              <span>Crea utente</span>
            </button>
            <div class="staff-users-toolbar__shortcuts" role="group" aria-label="Elenchi utenti">
              <button type="button" @click="goToTopUsers" class="create-user-button staff-button-neutral">
                <span class="material-icons" aria-hidden="true">star</span>
                <span>Utenti TOP</span>
              </button>
              <button type="button" @click="goToExpiringUsers" class="create-user-button staff-button-neutral">
                <span class="material-icons" aria-hidden="true">event_busy</span>
                <span>Scadenze imminenti</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Tabella degli utenti -->
        <p class="table-scroll-hint">Scorri orizzontalmente per vedere tutte le colonne.</p>
        <div class="tickets users-table-scroll" tabindex="0" role="region" aria-label="Elenco utenti, tabella scorrevole">
          <table class="users-table">
            <thead>
              <tr>
                <th class="created-column">Data di Creazione</th>
                <th class="email-column">Email</th>
                <th class="order-column">Ordine</th>
                <th class="name-column">Nome</th>
                <th class="surname-column">Cognome</th>
                <th>Studio</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in filteredUsers" :key="user.uid">
                <td class="created-cell">{{ formatDate(user.created_time) }}</td>
                <td class="email-cell">
                  <div class="email-text" :title="user.email">{{ user.email }}</div>
                </td>
                <td class="order-cell">
                  <button
                    type="button"
                    class="order-badge"
                    :class="`order-badge--${orderBadgeStatus(user)}`"
                    @click="showLastOrder(user)"
                    title="Mostra ultimo ordine"
                    aria-label="Mostra ultimo ordine"
                  >
                    <span class="material-icons" aria-hidden="true">receipt_long</span>
                  </button>
                </td>
                <td>{{ user.name }}</td>
                <td>{{ user.surname }}</td>
                <td>{{ user.studio }}</td>
                <td class="actions-cell">
  <div class="buttons-container">
    <a
      class="staff-button-neutral"
      :href="newTabHref({ name: 'UserDetails', params: { userId: user.uid } })"
      target="_blank"
      rel="noopener noreferrer"
      title="Apri profilo in una nuova scheda"
      aria-label="Apri profilo in una nuova scheda"
    >
      <span class="material-icons" aria-hidden="true">visibility</span>
    </a>

    <a
      class="staff-button-neutral"
      :href="newTabHref({ name: 'UserComunicazioni', params: { userId: user.uid } })"
      target="_blank"
      rel="noopener noreferrer"
      title="Apri comunicazioni in una nuova scheda"
      aria-label="Apri comunicazioni in una nuova scheda"
    ><span class="material-icons" aria-hidden="true">task_alt</span></a>
    <button type="button" class="staff-button-neutral" @click="viewTechnicalConversation(user)" title="Apri assistenza tecnica" aria-label="Apri assistenza tecnica"><span class="material-icons" aria-hidden="true">fitness_center</span></button>
    <!-- Pallino colorato -->
    <span 
      v-if="user.ticketStatus" 
      :class="{
        orange: user.ticketStatus === 'Aperto',
        green: user.ticketStatus === 'Risposto',
        yellow: user.ticketStatus === 'Non Risposto'
      }" 
      class="status-dot">
    </span>
  </div>
</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>

    <!-- Modale per la creazione di una nuova conversazione -->
    <div v-if="showCreateConversationModal" class="modal staff-form-modal">
    <div class="modal-content">
      <span class="close" @click="closeCreateConversationModal">&times;</span>
      <h2>Apri una nuova conversazione tecnica</h2>
      
      <form @submit.prevent="createConversation">
        <div>
          <label for="title">Titolo del messaggio:</label>
          <input type="text" v-model="newConversation.title" placeholder="Inserisci il titolo..." />
        </div>
        
        <div>
          <label for="message">Messaggio:</label>
          <textarea v-model="newConversation.message" placeholder="Scrivi il tuo messaggio..."></textarea>
        </div>

        <button class="staff-button-neutral" type="button" @click="openDeliveryMessagesModal">Messaggi di consegna</button>
        
        <button class="staff-button-positive" type="submit" :disabled="isCreatingConversation">{{ isCreatingConversation ? 'Invio…' : 'Crea Conversazione' }}</button>
      </form>
    </div>
  </div>

  <div class="modal" v-if="showDeliveryMessagesModal">
    <div class="modal-content">
      <span class="close" @click="closeDeliveryMessagesModal">&times;</span>
      <h2>Messaggi di Consegna</h2>
      <div class="message-section" v-for="(message, index) in deliveryMessages" :key="index">
        <h3>{{ message.title }}</h3>
        <pre v-html="truncateMessage(message.content, index)"></pre>
        <div class="message-actions">
          <button class="staff-button-neutral" v-if="!showFullMessage[index]" @click="toggleFullMessage(index)">Mostra tutto</button>
          <button class="staff-button-neutral" v-else @click="toggleFullMessage(index)">Mostra meno</button>
          <button class="copy-button staff-button-neutral" @click="copyMessageToConversation(message.content)">Copia nel messaggio</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" v-if="showOrderModal">
    <div class="modal-content order-modal">
      <span class="close" @click="closeOrderModal">&times;</span>
      <h2>Ultimo ordine</h2>

      <div v-if="orderLoading" class="order-loader">Caricamento…</div>
      <div v-else-if="orderError" class="order-error">{{ orderError }}</div>
      <div v-else-if="selectedOrder" class="order-card">
        <div class="order-card__body">
          <div class="order-field">
            <span class="order-field__label">Codice</span>
            <span class="order-field__value">{{ orderSummary.code }}</span>
          </div>
          <div class="order-field">
            <span class="order-field__label">Data</span>
            <span class="order-field__value">{{ orderSummary.date }}</span>
          </div>
          <div class="order-field" v-if="orderSummary.status && orderSummary.status !== '—'">
            <span class="order-field__label">Stato</span>
            <span class="order-field__value">{{ orderSummary.status }}</span>
          </div>
          <div class="order-field">
            <span class="order-field__label">Totale</span>
            <span class="order-field__value">{{ orderSummary.total }}</span>
          </div>
          <div class="order-field order-field--products" v-if="orderSummary.products.length">
            <span class="order-field__label">Prodotti</span>
            <ul class="order-products">
              <li
                v-for="(product, index) in orderSummary.products"
                :key="index"
                :class="productHighlightClass(product)"
              >
                {{ product }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-else class="order-empty">Nessun ordine trovato per questo utente.</div>
    </div>
  </div>


  <dialog
    ref="createUserDialog"
    class="staff-editor-dialog staff-user-create-dialog"
    aria-labelledby="staff-user-create-title"
    aria-describedby="staff-user-create-description"
    @cancel.prevent="closeModal"
    @close="!createUserDialog?.open && closeModal()"
    @click.self="handleCreateUserBackdrop"
  >
    <header class="staff-editor-header">
      <span class="material-icons staff-editor-heading-icon" aria-hidden="true">person_add</span>
      <div>
        <h2 id="staff-user-create-title">Crea nuovo utente</h2>
        <p id="staff-user-create-description">Anagrafica e accesso alla piattaforma.</p>
      </div>
      <button type="button" class="staff-editor-close staff-button-neutral" aria-label="Chiudi creazione utente" title="Chiudi creazione utente" @click="closeModal" autofocus>
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>

    <form class="staff-editor-form" @submit.prevent="createUser" :aria-busy="isLoading">
      <div class="staff-editor-body">
        <div class="staff-user-create-notice" role="note">
          <span class="material-icons" aria-hidden="true">mail_outline</span>
          <p>L’utente riceverà un’email con la password temporanea <strong>Fusco6202</strong> per il primo accesso. Potrà cambiarla dopo aver effettuato l’accesso.</p>
        </div>
        <fieldset class="staff-editor-section">
          <legend>Dati utente</legend>
          <div class="staff-editor-grid staff-editor-grid--two">
            <label class="staff-editor-field">
              <span>Nome</span>
              <input type="text" v-model="newUser.name" placeholder="Nome" />
            </label>
            <label class="staff-editor-field">
              <span>Cognome</span>
              <input type="text" v-model="newUser.surname" placeholder="Cognome" />
            </label>
            <label class="staff-editor-field">
              <span>Email</span>
              <input type="email" v-model="newUser.email" placeholder="nome@esempio.it" />
            </label>
            <label class="staff-editor-field">
              <span>Studio</span>
              <select v-model="newUser.studio">
                <option disabled value="">Seleziona uno studio</option>
                <option value="Tivoli Quartier generale">Tivoli Quartier generale</option>
                <option value="FF Genova">FF Genova</option>
                <option value="FF Bologna">FF Bologna</option>
                <option value="FF Bari">FF Bari</option>
                <option value="FF Pescara">FF Pescara</option>
                <option value="FF Firenze">FF Firenze</option>
                <option value="FF Torino">FF Torino</option>
                <option value="FF Napoli">FF Napoli</option>
                <option value="FF Milano">FF Milano</option>
                <option value="FF Roma">FF Roma</option>
                <option value="FF Salerno">FF Salerno</option>
                <option value="FF Cagliari">FF Cagliari</option>
                <option value="FF Milano Citta Studi">FF Milano Città Studi</option>
                <option value="FF Roma Eur">FF Roma Eur</option>
                <option value="FF Milano Sempione">FF Milano Sempione</option>
                <option value="FF Padova">FF Padova</option>
              </select>
            </label>
          </div>
        </fieldset>
      </div>

      <footer class="staff-editor-footer">
        <p v-if="isLoading" role="status">Creazione in corso…</p>
        <div class="staff-editor-actions">
          <button type="button" class="staff-editor-button staff-editor-cancel staff-button-cancel" @click="closeModal">Annulla</button>
          <button type="submit" class="staff-editor-button staff-editor-save staff-button-positive" :disabled="isLoading">
            <span class="material-icons" aria-hidden="true">person_add</span>
            <span>{{ isLoading ? 'Creazione…' : 'Crea utente' }}</span>
          </button>
        </div>
      </footer>
    </form>
  </dialog>

</template>



<script>
import { ref, watch, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { getFirestore, collection, getDocs, query, limit, where, orderBy, updateDoc, doc, startAt, endAt } from 'firebase/firestore';
import SidebarComponent from '../SidebarComponent.vue'; 
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import { useOrderBadge } from '@/composables/useOrderBadge';
import { createTechnicalTicket, createTechnicalMessageId } from '@/lib/technicalTicketMessages';



export default {
  
  components: {
    SidebarComponent,
  },
  setup() {
    const users = ref([]);
    const searchQuery = ref('');
    const showModal = ref(false);
    const createUserDialog = ref(null);
    watch(showModal, visible => {
      const dialog = createUserDialog.value;
      if (!dialog) return;
      if (visible && !dialog.open) dialog.showModal();
      else if (!visible && dialog.open) dialog.close();
    }, { flush: 'post' });
    const showCreateConversationModal = ref(false); // Nuovo stato per il modale
    const newConversation = ref({ title: '', message: '' }); // Nuovo stato per la nuova conversazione
    const isCreatingConversation = ref(false);
    let pendingConversation = null;
    const showDeliveryMessagesModal = ref(false);
    const showFullMessage = ref([]);
    const deliveryMessages = ref([
      
      {
        title: 'MESSAGGIO POST ACQUISTO - PROGRAMMA COMPLETO:',
        content: `Ciaooo

benvenuta in Fusco Fit! 🎉

stiamo per costruire insieme il tuo percorso personalizzato.

Ecco come funziona, passo dopo passo:

📋 Prossimi Step

<strong>1. Scarica la nostra app.</strong>
📲 Fusco Fit Connect (logo nero) → comunicazioni, assistenza, piano alimentare e allenamenti sono tutti nella stessa app.
🔍 Cerca “Fusco Fit Connect” nello store del tuo telefono e scaricala.
📝 Registrati usando la stessa email che ci hai fornito all’acquisto.

<strong>2. Compila il questionario che riceverai via email (se non lo hai già compilato).</strong>
📧 È indispensabile per costruire il tuo piano.
🖊️ Più sarai precisa (soprattutto nelle note libere), più riusciremo a personalizzare il tuo percorso.
📬 Dopo l’invio, potresti ricevere via mail una richiesta di approfondimento: controlla spesso la posta.

<strong>3. Video call con la nutrizionista</strong>
Dopo che il tuo questionario sarà approvato, verrai contattata per fissare l’appuntamento in videocall, se non riesci a rispondere richiamaci appena puoi.
La call è indispensabile per perfezionare il piano alimentare e per ricevere l’allenamento.

<strong>4. Se il tuo piano prevede una call tecnica (servizio plus)</strong>
Riceverai un messaggio nell’app Fusco Fit Connect (logo nero) per fissare la videocall.
📅 In quel momento ti chiederemo di indicarci le tue fasce orarie di disponibilità per prenotarla, chiaramente dopo la consegna delle programmazioni.

<strong>5. Consegna del programma</strong>
Nei 2 giorni lavorativi successivi alla call con la nutrizionista prepareremo il tuo piano.
📲 La consegna sarà pronta quando riceverai il messaggio di conferma nell’app Fusco Fit Connect (logo nero).
📂 Il piano alimentare sarà nella sezione Alimentazione.
💪 Il programma di allenamento sarà nella sezione Allenamenti della stessa app.

<strong>➡️ Dopo la consegna</strong>
Potrai iniziare subito a seguire il tuo percorso.
Per dubbi o chiarimenti, scrivici illimitatamente su “assistenza tecnica” nell’app Fusco Fit Connect (logo nero), mentre per dubbi alimentari avrai a disposizione 2 ticket al mese su “assistenza nutrizionale”.

<strong>📌 Nota importante sulle call tecniche</strong>
La call tecnica può essere utilizzata solo all’interno del programma in corso.
Esempio: se hai acquistato 6 programmi → avrai diritto a 1 call per ogni programma.
👉 Una volta terminato il singolo programma, anche la call associata scade se non è stata utilizzata.
Prima di effettuare la videocall segnati ogni dubbio che hai sulla scheda, così li analizzeremo INSIEME❤️

<strong>💪🏻Orari assistenza💪🏻</strong>
Il nostro team è disponibile:
🕘 Lunedì – Venerdì dalle 9:00 alle 19:00
🕙 Sabato dalle 10:00 alle 13:00`
      },
      {
        title: 'MESSAGGIO POST ACQUISTO - SOLO ALLENAMENTO:',
        content: `Ciaooo

benvenuta in Fusco Fit! 🎉

stiamo per costruire insieme il tuo percorso personalizzato.

Ecco come funziona, passo dopo passo:

📋 Prossimi Step

<strong>1. Scarica la nostra app.</strong>
📲 Fusco Fit Connect (logo nero) → comunicazioni, assistenza e allenamenti sono tutti nella stessa app.
🔍 Cerca “Fusco Fit Connect” nello store del tuo telefono e scaricala.
📝 Registrati usando la stessa email che ci hai fornito all’acquisto.

<strong>2.Compila il questionario che riceverai via email (se non lo hai già compilato).</strong>
📧 È indispensabile per costruire il tuo piano.
🖊️ Più sarai precisa (soprattutto nelle note libere), più riusciremo a personalizzare il tuo percorso.
📬 Dopo l’invio, potresti ricevere via mail una richiesta di approfondimento: controlla spesso la posta.
	
<strong>3.Se il tuo piano prevede una call tecnica (servizio plus)</strong>
Riceverai un messaggio nell’app Fusco Fit Connect (logo nero) per fissare la videocall.
📅 In quel momento ti chiederemo di indicarci le tue fasce orarie di disponibilità per prenotarla, chiaramente dopo la consegna delle programmazioni.

<strong>4.Consegna del programma</strong>
📲 La consegna sarà pronta quando riceverai il messaggio di conferma nell’app Fusco Fit Connect (logo nero).
💪 Il tuo programma di allenamento sarà caricato nella sezione Allenamenti della stessa app.

<strong>➡️ Dopo la consegna</strong>
Potrai iniziare subito a seguire il tuo percorso.
Per dubbi o chiarimenti, scrivici illimitatamente su “assistenza tecnica” nell’app Fusco Fit Connect (logo nero).

<strong>📌 Nota importante sulle call tecniche</strong>
La call tecnica può essere utilizzata solo all’interno del programma in corso.
Esempio: se hai acquistato 6 programmi → avrai diritto a 1 call per ogni programma.
👉 Una volta terminato il singolo programma, anche la call associata scade se non è stata utilizzata.
Prima di effettuare la videocall segnati ogni dubbio che hai sulla scheda, così li analizzeremo INSIEME❤️

<strong>💪🏻Orari assistenza💪🏻</strong>
Il nostro team è disponibile:
🕘 Lunedì – Venerdì dalle 9:00 alle 19:00
🕙 Sabato dalle 10:00 alle 13:00`
      },
      {
        title: 'MESSAGGIO POST ACQUISTO - SOLO DIETA:',
        content: `Ciaooooo

benvenuta in Fusco Fit! 🎉

stiamo per costruire insieme il tuo percorso personalizzato.

Ecco come funziona, passo dopo passo:

📋 Prossimi Step

<strong>1. Scarica la nostra app.</strong>
📲 Fusco Fit Connect (logo nero) → utile per le comunicazioni, assistenza e piano alimentare.
🔍 Cerca “Fusco Fit Connect” nello store del tuo telefono e scaricala.
📝 Registrati usando la stessa email che ci hai fornito all’acquisto.

<strong>2. Compila il questionario che riceverai via email (se non lo hai già compilato).</strong>
📧 È indispensabile per costruire il tuo piano.
🖊️ Più sarai precisa (soprattutto nelle note libere), più riusciremo a personalizzare il tuo percorso.
📬 Dopo l’invio, potresti ricevere via mail una richiesta di approfondimento: controlla spesso la posta.

<strong>3. Video call con la nutrizionista</strong>
Dopo che il tuo questionario sarà approvato, verrai contattata per fissare l’appuntamento in videocall, se non riesci a rispondere richiamaci appena puoi.
La call è indispensabile per perfezionare il piano alimentare.
	
<strong>5. Consegna del programma</strong>
Nei 2 giorni lavorativi successivi alla call con la nutrizionista prepareremo il tuo piano.
📲 La consegna sarà pronta quando riceverai il messaggio di conferma nell’app Fusco Fit Connect (logo nero).
📂 Il tuo piano alimentare sarà nella sezione Alimentazione di Fusco Fit Connect (logo nero).

<strong>➡️ Dopo la consegna</strong>
Potrai iniziare subito a seguire il tuo percorso.
Per dubbi o chiarimenti, scrivici illimitatamente su “assistenza tecnica” nell’app Fusco Fit Connect (logo nero), mentre per dubbi alimentari avrai a disposizione 2 ticket al mese su “assistenza nutrizionale”.

<strong>💪🏻Orari assistenza💪🏻</strong>
Il nostro team è disponibile:
🕘 Lunedì – Venerdì dalle 9:00 alle 19:00
🕙 Sabato dalle 10:00 alle 13:00`
      },

    ]);
    const newUser = ref({ name: '', surname: '', email: '', studio: '' });
    const selectedUserId = ref(null); // Nuova variabile per memorizzare l'ID dell'utente
    const isLoading = ref(false);
    const isLoading2 = ref(false);

    const {
      showOrderModal,
      orderLoading,
      orderError,
      selectedOrder,
      orderSummary,
      openLastOrder,
      closeOrderModal,
      orderBadgeStatus,
      productHighlightClass,
      prefetchUserHighlights,
    } = useOrderBadge();

    const showLastOrder = openLastOrder;

    const db = getFirestore();
    const router = useRouter();
    const searchEmail = ref('');
    const searchSurname = ref('');
    const searchPhone = ref('');
    const selectedFile = ref(null);  // Variabile per memorizzare il file selezionato


    const loadTicketStatuses = async () => {
  const ticketsCollection = collection(db, 'assistenzatecnica');
  try {
    const userIds = users.value.map((user) => user.uid); // Ottieni tutti gli UID degli utenti attualmente visualizzati
    if (!userIds.length) {
      return;
    }
    const querySnapshot = await getDocs(
      query(ticketsCollection, where('userId', 'in', userIds))
    );

    // Associa lo stato di ciascun ticket all'utente corrispondente
    const ticketStatuses = {};
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      ticketStatuses[data.userId] = data.status; // Salva lo stato del ticket
    });

    // Aggiorna la lista degli utenti con lo stato del ticket
    users.value = users.value.map((user) => ({
      ...user,
      ticketStatus: ticketStatuses[user.uid] || null, // Aggiungi il ticketStatus
    }));
  } catch (error) {
    console.error('Errore nel caricamento degli stati dei ticket:', error);
  }
};







    const handleFileChange = (event) => {
      selectedFile.value = event.target.files[0];  // Memorizza il file selezionato
    };


    const newTabHref = (route) => router.resolve(route).href;

    const openInNewTab = (route) => {
      window.open(newTabHref(route), '_blank', 'noopener');
    };

    const getCandidateUserIds = (user) => {
      if (!user) {
        return [];
      }
      if (typeof user === 'string') {
        return [user];
      }
      return [user.uid, user.userId, user.id].filter(Boolean);
    };

    const fetchTicketIdForUser = async (userIds) => {
      const candidateIds = Array.isArray(userIds) ? userIds : [userIds];
      const uniqueIds = Array.from(new Set(candidateIds.filter(Boolean)));
      if (!uniqueIds.length) {
        console.error('Errore: userId non definito');
        return null;
      }

      console.log("Tentativo di recuperare il ticket per l'utente:", uniqueIds);
      try {
        const ticketsRef = collection(db, 'assistenzatecnica');
        const q =
          uniqueIds.length === 1
            ? query(ticketsRef, where('userId', '==', uniqueIds[0]))
            : query(ticketsRef, where('userId', 'in', uniqueIds.slice(0, 10)));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const ticketDoc = querySnapshot.docs[0];
          return ticketDoc.id;
        }
        return null;
      } catch (error) {
        console.error('Errore nel recupero del ticketId:', error);
        return null;
      }
    };

    const viewTechnicalConversation = async (user) => {
      const candidateIds = getCandidateUserIds(user);
      const userId = candidateIds[0];
      if (!userId) {
        console.error('Errore: userId non definito');
        return;
      }

      console.log("Avvio del recupero della conversazione tecnica per l'utente:", userId);

      const pendingTab = window.open('about:blank', '_blank');
      if (pendingTab) {
        pendingTab.opener = null;
      }

      try {
        const ticketId = await fetchTicketIdForUser(candidateIds);

        if (ticketId) {
          const route = {
            name: 'UserConversationTecnica',
            params: { userId, ticketId },
          };
          const resolved = router.resolve(route);
          if (pendingTab) {
            pendingTab.location.href = resolved.href;
          } else {
            openInNewTab(route);
          }
        } else {
          // Se non esiste una conversazione, apriamo il modale
          if (pendingTab) {
            pendingTab.close();
          }
          selectedUserId.value = userId; // Memorizziamo l'ID dell'utente
          showCreateConversationModal.value = true; // Mostra il modale
        }
      } catch (error) {
        if (pendingTab) {
          pendingTab.close();
        }
        console.error('Errore durante il recupero della conversazione tecnica:', error);
      }
    };





    // Funzione per chiudere il modale di creazione conversazione
    const closeCreateConversationModal = () => {
      showCreateConversationModal.value = false;
      newConversation.value = { title: '', message: '' }; // Resetta il form
      pendingConversation = null;
    };

    // Funzione per creare la nuova conversazione
    const createConversation = async () => {
      if (isCreatingConversation.value) return;
      const draft = newConversation.value;
      const userId = selectedUserId.value;
      const title = draft.title.trim();
      const content = draft.message.trim();
      if (!userId || !title || !content) {
        alert('Inserisci un titolo e un messaggio per la conversazione.');
        return;
      }
      const operatorId = getAuth().currentUser?.uid;
      if (!operatorId) {
        console.error("Errore: ID dell'operatore non trovato.");
        return;
      }
      const originalTitle = draft.title;
      const originalMessage = draft.message;
      const key = JSON.stringify([operatorId, userId, originalTitle, originalMessage]);
      if (pendingConversation?.key !== key) {
        pendingConversation = { key, payload: { userId, title, content, messageId: createTechnicalMessageId() } };
      }
      const request = pendingConversation;
      const isCurrentDraft = () => selectedUserId.value === userId && newConversation.value === draft
        && draft.title === originalTitle && draft.message === originalMessage;
      isCreatingConversation.value = true;
      try {
        const result = await createTechnicalTicket(request.payload);
        if (pendingConversation === request) pendingConversation = null;
        if (isCurrentDraft()) {
          alert(result.created === false ? 'Messaggio inviato nella conversazione esistente!' : 'Conversazione creata con successo!');
          closeCreateConversationModal();
        }
        return result;
      } catch (error) {
        console.error('Errore durante la creazione della conversazione:', error);
        if (isCurrentDraft()) alert('Errore durante la creazione della conversazione.');
      } finally {
        isCreatingConversation.value = false;
      }
    };

    const openDeliveryMessagesModal = () => {
      showFullMessage.value = deliveryMessages.value.map(() => false);
      showDeliveryMessagesModal.value = true;
    };

    const closeDeliveryMessagesModal = () => {
      showDeliveryMessagesModal.value = false;
    };

    const copyMessageToConversation = (content) => {
      const currentMessage = newConversation.value?.message;
      if (typeof currentMessage === 'string' && currentMessage.length > 0) {
        newConversation.value.message += '\n' + content;
      } else {
        newConversation.value.message = content;
      }

      closeDeliveryMessagesModal();
    };

    const truncateMessage = (message = '', index) => {
      if (showFullMessage.value[index]) {
        return message;
      }
      return message.length > 150 ? message.slice(0, 150) + '...' : message;
    };

    const toggleFullMessage = (index) => {
      showFullMessage.value[index] = !showFullMessage.value[index];
    };



    const formatDate = (timestamp) => {
      if (timestamp && typeof timestamp.toDate === 'function') {
        const date = timestamp.toDate();
        return date.toLocaleDateString("it-IT");
      } else {
        return 'Data non valida';
      }
    };

    const fetchInitialUsers = async () => {
  try {
    const querySnapshot = await getDocs(
      query(collection(db, 'users'), orderBy('created_time', 'desc'), limit(20))
    );

    users.value = querySnapshot.docs.map((doc) => ({
      uid: doc.id,
      ...doc.data(),
    }));

    // Carica lo stato dei ticket dopo aver caricato gli utenti
    await loadTicketStatuses();
    await prefetchUserHighlights(users.value);
  } catch (error) {
    console.error('Errore nel caricamento degli utenti:', error);
  }
};




const importUsers = async () => {
      const file = selectedFile.value;
      if (file) {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const text = e.target.result;
          const rows = text.split('\n');
          for (let i = 1; i < rows.length; i++) {
            const cells = rows[i].split(';');
            if (cells.length > 1) {
              const userId = cells[0].trim();
              const email = cells[1].trim();
              const name = cells[2].trim();
              const surname = cells[3].trim();
              const studio = cells[4].trim();
              const uid = cells[5].trim();
              const phone = cells[6].trim();
              const indirizzo = cells[7].trim();
              const cap = cells[8].trim();
              const regione = cells[9].trim();
              const provincia = cells[10].trim();
              const luogoNascita = cells[11].trim();


              const userRef = doc(db, "users", userId);
              await updateDoc(userRef, {
                email: email,
                name: name,
                surname: surname,
                studio: studio,
                uid: uid,
                phone: phone,
                indirizzo: indirizzo,
                cap: cap,
                regione: regione,
                provincia: provincia,
                luogoNascita: luogoNascita,
              });
            }
          }
          alert('Importazione completata con successo!');
        };
        reader.onerror = (error) => {
          console.error('Errore nella lettura del file:', error);
          alert('Errore nella lettura del file. Si prega di riprovare.');
        };
        reader.readAsText(file);
      } else {
        alert('Nessun file selezionato. Seleziona un file prima di importare.');
      }
    };



// Metodo per aggiornare gli utenti da un file CSV
const updateUsersFromCSV = async (event) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const text = e.target.result;
          const rows = text.split('\n');
          for (let i = 1; i < rows.length; i++) {
            const cells = rows[i].split(',');
            if (cells.length > 1) {
              const userId = cells[0];
              const email = cells[1];
              const name = cells[2];
              const surname = cells[3];
              const studio = cells[4];
              const uid = cells[5].trim();
              const phone = cells[6];
              const indirizzo = cells[7];
              const cap = cells[8];
              const regione = cells[9];
              const provincia = cells[10];
              const luogoNascita = cells[11];

              const userRef = doc(db, "users", userId);
              await updateDoc(userRef, {
                email: email,
                name: name,
                surname: surname,
                studio: studio,
                uid: uid,
                phone: phone,
                indirizzo: indirizzo,
                cap: cap,
                regione: regione,
                provincia: provincia,
                luogoNascita: luogoNascita,
              });
            }
          }
        };
        reader.readAsText(file);
      }
    };

    // Metodo per esportare gli utenti in CSV
    const exportUsersToCSV = async () => {
      const querySnapshot = await getDocs(collection(db, "users"));
      const usersArray = querySnapshot.docs.map(doc => ({
        UserId: doc.id,
        email: doc.data().email,
        name: doc.data().name,
        surname: doc.data().surname,
        studio: doc.data().studio,
        uid: doc.data().uid,
        phone: doc.data().phone,
      }));

      let csvContent = "data:text/csv;charset=utf-8,ID Documento,Email,Nome,Cognome,Studio,uid\n";
      usersArray.forEach(user => {
        let row = `${user.UserId},${user.email},${user.name},${user.surname},${user.studio},${user.uid},${user.phone}\n`;
        csvContent += row;
      });

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "elenco_utenti.csv");
      document.body.appendChild(link); // Required for FF
      link.click();
      document.body.removeChild(link);
    };




const handleSearch = async () => {
  // Controlla se entrambi i campi sono vuoti
  if (!searchEmail.value && !searchSurname.value && !searchPhone.value) {
    // Se entrambi i campi sono vuoti, carica gli utenti iniziali
    await fetchInitialUsers();
    return;
  }
  isLoading2.value = true; // Attiva il loader

  await searchUsers(); // Avvia la ricerca

  isLoading2.value = false; // Disattiva il loader al termine
};


    const SURNAME_FETCH_LIMIT = 2000;

    const normalizePhoneDigits = (value = '') => value.replace(/\D/g, '');

    const removeItalianPrefix = (digits) => {
      if (!digits) {
        return '';
      }

      if (digits.startsWith('0039')) {
        return digits.slice(4);
      }

      if (digits.startsWith('39')) {
        return digits.slice(2);
      }

      return digits;
    };

    const buildPhoneVariants = (term) => {
      const variants = new Set();
      const trimmed = (term || '').trim();

      if (!trimmed) {
        return [];
      }

      variants.add(trimmed);

      const digitsOnly = normalizePhoneDigits(trimmed);
      if (!digitsOnly) {
        return Array.from(variants);
      }

      variants.add(digitsOnly);
      variants.add(`+${digitsOnly}`);

      const localPart = removeItalianPrefix(digitsOnly);
      if (localPart) {
        variants.add(localPart);
        ['39', '+39', '0039'].forEach((prefix) => {
          variants.add(`${prefix}${localPart}`);
        });
      }

      return Array.from(
        Array.from(variants).filter((value) => value && value !== '+')
      );
    };

    const runPhoneSearch = async (term) => {
      const variants = buildPhoneVariants(term);
      if (!variants.length) {
        return [];
      }

      const usersCollection = collection(db, 'users');
      const queries = variants.map((value) =>
        getDocs(query(usersCollection, where('phone', '==', value)))
      );

      const snapshots = await Promise.allSettled(queries);
      const resultsMap = new Map();

      snapshots.forEach((result) => {
        if (result.status !== 'fulfilled') {
          console.warn('Ricerca telefono non riuscita per una query:', result.reason);
          return;
        }

        result.value.forEach((docSnap) => {
          const data = docSnap.data() || {};
          resultsMap.set(docSnap.id, { uid: docSnap.id, ...data });
        });
      });

      return Array.from(resultsMap.values());
    };

    const capitalizeFirst = (value) => {
      if (!value) {
        return '';
      }
      return value.charAt(0).toUpperCase() + value.slice(1);
    };

    const runSurnameSearch = async (term) => {
      const trimmed = term.trim();
      if (!trimmed) {
        return [];
      }

      const lower = trimmed.toLowerCase();
      const capitalized = capitalizeFirst(lower);
      const upper = trimmed.toUpperCase();
      const firstUpper = capitalized.charAt(0);
      const firstLower = firstUpper.toLowerCase();
      const prefixes = new Set();

      if (capitalized) {
        prefixes.add(capitalized);
      }
      if (trimmed && trimmed !== capitalized) {
        prefixes.add(trimmed);
      }
      if (upper && upper !== capitalized) {
        prefixes.add(upper);
      }
      if (firstUpper) {
        prefixes.add(firstUpper);
      }
      if (firstLower && firstLower !== firstUpper) {
        prefixes.add(firstLower);
      }

      if (!prefixes.size) {
        prefixes.add('');
      }

      const usersCollection = collection(db, 'users');
      const queries = Array.from(prefixes).map((value) =>
        getDocs(
          query(
            usersCollection,
            orderBy('surname'),
            startAt(value),
            endAt(`${value}\uf8ff`),
            limit(SURNAME_FETCH_LIMIT)
          )
        )
      );

      const snapshots = await Promise.allSettled(queries);
      const resultsMap = new Map();

      snapshots.forEach((result) => {
        if (result.status !== 'fulfilled') {
          console.warn('Ricerca cognome non riuscita per una query:', result.reason);
          return;
        }

        result.value.forEach((docSnap) => {
          const data = docSnap.data() || {};
          const surnameValue = (data.surname || '').toString();
          const surnameLower = surnameValue.trim().toLowerCase();
          if (!surnameLower.includes(lower)) {
            return;
          }
          if (!resultsMap.has(docSnap.id)) {
            resultsMap.set(docSnap.id, { uid: docSnap.id, ...data });
          }
        });
      });

      return Array.from(resultsMap.values());
    };

    const searchUsers = async () => {
      const combinedResults = new Map();

      if (searchEmail.value) {
        const searchQuery = query(collection(db, 'users'), where('email', '==', searchEmail.value));
        const querySnapshot = await getDocs(searchQuery);
        querySnapshot.forEach((doc) => {
          combinedResults.set(doc.id, { uid: doc.id, ...doc.data() });
        });
      }

      if (searchSurname.value) {
        const surnameMatches = await runSurnameSearch(searchSurname.value);
        surnameMatches.forEach((userRecord) => {
          combinedResults.set(userRecord.uid, userRecord);
        });
      }

      if (searchPhone.value) {
        const phoneMatches = await runPhoneSearch(searchPhone.value);
        phoneMatches.forEach((userRecord) => {
          combinedResults.set(userRecord.uid, userRecord);
        });
      }

      // Converti i risultati in un array
      const searchResults = Array.from(combinedResults.values());
  users.value = searchResults; // Aggiorna la lista utenti

  // Carica lo stato dei ticket solo per gli utenti cercati
  await loadTicketStatusesForSearch(searchResults);
  await prefetchUserHighlights(users.value);
};




const loadTicketStatusesForSearch = async (searchResults) => {
  const ticketsCollection = collection(db, 'assistenzatecnica');

  try {
    const userIds = searchResults.map((user) => user.uid); // Ottieni tutti gli UID degli utenti cercati
    if (!userIds.length) {
      return;
    }
    const querySnapshot = await getDocs(
      query(ticketsCollection, where('userId', 'in', userIds))
    );

    // Associa lo stato di ciascun ticket all'utente corrispondente
    const ticketStatuses = {};
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      ticketStatuses[data.userId] = data.status; // Salva lo stato del ticket
    });

    // Aggiorna la lista degli utenti con lo stato del ticket
    users.value = users.value.map((user) => ({
      ...user,
      ticketStatus: ticketStatuses[user.uid] || null, // Aggiungi il ticketStatus
    }));
  } catch (error) {
    console.error('Errore nel caricamento degli stati dei ticket durante la ricerca:', error);
  }
};



    onMounted(fetchInitialUsers);

    const filteredUsers = computed(() => {
      return users.value.filter(user => {
        return Object.values(user).join(' ').toLowerCase().includes(searchQuery.value.toLowerCase());
      });
    });

    const openCreateUserModal = () => {
      showModal.value = true;
    };

    const goToTopUsers = () => {
      router.push({ path: '/users-top-list' });
    };

    const goToExpiringUsers = () => {
      router.push({ path: '/users-expiring-list' });
    };

    const closeModal = () => {
      showModal.value = false;
      newUser.value = { name: '', surname: '', email: '', studio:'' };
    };

    const handleCreateUserBackdrop = event => {
      const rect = createUserDialog.value?.getBoundingClientRect();
      if (rect && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) {
        closeModal();
      }
    };

    const createUser = async () => {
  const functions = getFunctions(); // Assicurati che Firebase sia configurato correttamente
  const createUserFn = httpsCallable(functions, 'createUser');
  isLoading.value = true; // Avvia il loader

  try {
    const result = await createUserFn({
      email: newUser.value.email,
      password: 'Fusco6202', // Considera una strategia sicura per la gestione delle password
      name: newUser.value.name,
      surname: newUser.value.surname,
      studio: newUser.value.studio,
    });

    console.log(result.data); // Gestisci il risultato come necessario
    fetchInitialUsers(); // Aggiorna l'elenco degli utenti
    closeModal(); // Chiudi il modal
  } catch (error) {
    console.error("Errore durante la creazione dell'utente tramite Cloud Function:", error);

    // Aggiungi un console log dettagliato
    console.log("Messaggio di errore:", error.message);

    // Verifica l'errore specifico
    if (error.message.includes('The email address is already in use by another account.')) {
      alert('Utente già esistente');
    } else {
      alert('Errore durante la creazione dell\'utente');
    }
  } finally {
    isLoading.value = false; // Ferma il loader
  }
};





    return { users, searchQuery, filteredUsers, newTabHref, formatDate, showModal, newUser, openCreateUserModal, closeModal, createUser, searchEmail, searchSurname, searchPhone, isLoading, isLoading2, exportUsersToCSV, updateUsersFromCSV, importUsers, handleFileChange,
      createUserDialog,
      handleCreateUserBackdrop,
      viewTechnicalConversation,
      showCreateConversationModal,
      newConversation,
      isCreatingConversation,
      createConversation,
      closeCreateConversationModal,
      openDeliveryMessagesModal,
      closeDeliveryMessagesModal,
      showDeliveryMessagesModal,
      deliveryMessages,
      showFullMessage,
      copyMessageToConversation,
      truncateMessage,
      toggleFullMessage,
      orderSummary,
      showOrderModal,
      orderLoading,
      orderError,
      selectedOrder,
      productHighlightClass,
      showLastOrder,
      closeOrderModal,
      orderBadgeStatus,
      handleSearch,
      goToTopUsers,
      goToExpiringUsers
    };
  },
};
</script>



<style scoped>
.content-container {
  min-width: 0;
}

.search-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
  margin: 24px 0;
  padding: 18px 20px;
  border-radius: 20px;
  border: 1px solid #dbe2f0;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
}

.search-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 220px;
  flex: 1 1 240px;
}

.search-bar {
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  background: #ffffff;
  padding: 10px 14px;
  font-size: 0.95rem;
  color: #0f172a;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.search-bar:focus {
  outline: none;
  border-color: rgba(99, 102, 241, 0.65);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

.search-container > button {
  flex: 0 0 auto;
}

.create-user-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 999px;
  border: none;
  background: linear-gradient(120deg, #22c55e, #16a34a);
  color: #ffffff;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(34, 197, 94, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.create-user-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 16px 34px rgba(34, 197, 94, 0.35);
  filter: saturate(1.1);
}

.create-user-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.minimal-loader {
  margin-left: 12px;
  font-size: 0.9rem;
  color: #2563eb;
  letter-spacing: 0.02em;
}

.table-scroll-hint {
  display: none;
  margin: 0 0 8px;
  font-size: 0.8rem;
  line-height: 1.4;
  color: #64748b;
}

.users-table-scroll {
  max-width: 100%;
  margin-top: 20px;
  overflow-x: auto;
  border: 1px solid #dbe2f0;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  scrollbar-color: #94a3b8 #eef2f7;
}

.users-table-scroll:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 3px;
}

.users-table {
  width: 100%;
  min-width: 1100px;
  margin: 0;
  padding: 0;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.875rem;
  line-height: 1.45;
  color: #0f172a;
  background: #ffffff;
  border-radius: 0;
  table-layout: fixed;
}

.users-table th,
.users-table td {
  box-sizing: border-box;
}

.users-table thead th {
  position: sticky;
  top: 0;
  z-index: 6;
  background: linear-gradient(180deg, #f7f9fc 0%, #eef2f7 100%);
  padding: 14px;
  font-weight: 600;
  font-size: 0.72rem;
  font-style: normal;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #0f172a;
  border-bottom: 1px solid #dbe2f0;
  white-space: nowrap;
}

.users-table thead th:last-child,
.users-table tbody td:last-child {
  position: sticky;
  right: 0;
  width: 180px;
  text-align: center;
  box-shadow: -8px 0 14px -12px rgba(15, 23, 42, 0.4);
}

.users-table thead th:last-child {
  z-index: 7;
}

.users-table tbody td:last-child {
  z-index: 1;
}

.users-table tbody tr {
  --row-bg: #ffffff;
  transition: background-color 0.2s ease;
}

.users-table tbody tr:nth-child(even) {
  --row-bg: #f8fafc;
}

.users-table tbody tr:hover {
  --row-bg: #eef6ff;
}

.users-table tbody td {
  padding: 14px;
  border-bottom: 1px solid #e4e9f2;
  vertical-align: middle;
  color: #0f172a;
  background: var(--row-bg);
  white-space: normal;
  word-break: normal;
  overflow-wrap: anywhere;
}

.users-table .created-column {
  width: 156px;
}

.users-table .name-column {
  width: 12%;
}

.users-table .surname-column {
  width: 13%;
}

.users-table tbody .created-cell,
.users-table tbody .actions-cell {
  white-space: nowrap;
  overflow-wrap: normal;
}

.users-table tbody .actions-cell {
  text-align: center;
}

.users-table .email-column {
  width: 24%;
}

.email-text {
  display: block;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.users-table .order-column {
  width: 76px;
  text-align: center;
}

.order-cell {
  text-align: center;
}

.order-badge {
  width: 34px;
  height: 34px;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.4);
  background: #f7f9fc;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.order-badge .material-icons {
  font-size: 20px;
}

.order-badge:hover {
  background: #e0e7ff;
  border-color: rgba(99, 102, 241, 0.55);
  color: #4338ca;
  transform: translateY(-1px);
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.12);
}

.order-badge--green {
  border: none;
  background: linear-gradient(120deg, #22c55e, #16a34a);
  color: #ffffff;
  box-shadow: 0 16px 34px rgba(34, 197, 94, 0.32);
}

.order-badge--green:hover {
  background: linear-gradient(120deg, #22c55e, #16a34a);
  border: none;
  box-shadow: 0 18px 40px rgba(34, 197, 94, 0.36);
  color: #ffffff;
}

.order-badge--orange {
  border: none;
  background: linear-gradient(120deg, #f97316, #ea580c);
  color: #ffffff;
  box-shadow: 0 16px 34px rgba(249, 115, 22, 0.28);
}

.order-badge--orange:hover {
  background: linear-gradient(120deg, #f97316, #ea580c);
  border: none;
  box-shadow: 0 18px 40px rgba(234, 88, 12, 0.32);
  color: #ffffff;
}

.order-badge--neutral {
  background: #f8fafc;
  border-color: rgba(148, 163, 184, 0.45);
}

.buttons-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.buttons-container :is(button, a) {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.3);
  background: #f7f9fc;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease, color 0.2s ease;
}

.buttons-container :is(button, a):hover {
  background: #e0e7ff;
  border-color: rgba(99, 102, 241, 0.6);
  color: #4338ca;
  transform: translateY(-1px);
}

.buttons-container :is(button, a):focus-visible {
  outline: 3px solid rgba(79, 70, 229, 0.28);
  outline-offset: 2px;
}

.buttons-container .material-icons {
  font-size: 20px;
}

.status-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 999px;
  box-shadow: 0 0 0 4px rgba(15, 23, 42, 0.05);
}

.status-dot.orange {
  background-color: #f59e0b;
}

.status-dot.green {
  background-color: #22c55e;
}

.status-dot.yellow {
  background-color: #facc15;
}

.modal {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.55);
  z-index: 2000;
  width: 100%;
}

.modal-content {
  position: relative;
  width: min(540px, 92vw);
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 24px;
  padding: 32px 36px;
  background: linear-gradient(180deg, #ffffff 0%, #f5f7fb 100%);
  box-shadow: 0 32px 70px rgba(15, 23, 42, 0.2);
  color: #0f172a;
}

.modal-content h2 {
  margin: 0 0 18px;
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  color:#0f172a
}

.modal-content form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.modal-content form > div {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.modal-content label {
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #475569;
}

.modal-content input,
.modal-content select,
.modal-content textarea {
  width: 100%;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  padding: 12px 14px;
  font-size: 0.96rem;
  color: #0f172a;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.modal-content textarea {
  min-height: 160px;
  resize: vertical;
  line-height: 1.6;
}

.modal-content input:focus,
.modal-content select:focus,
.modal-content textarea:focus {
  outline: none;
  border-color: rgba(99, 102, 241, 0.65);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

.close {
  position: absolute;
  top: 18px;
  right: 18px;
  font-size: 1.4rem;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.2s ease, transform 0.2s ease;
}

.close:hover {
  color: #64748b;
  transform: scale(1.05);
}

.order-modal .close {
  color: #e2e8f0;
}

.modal-content button[type="button"] {
  align-self: flex-start;
  padding: 10px 16px;
  border-radius: 12px;
  border: 1px solid rgba(99, 102, 241, 0.4);
  background: #f5f7ff;
  color: #4338ca;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 10px 22px rgba(99, 102, 241, 0.16);
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.modal-content button[type="button"]:hover {
  background: #eef2ff;
  transform: translateY(-1px);
  box-shadow: 0 14px 30px rgba(99, 102, 241, 0.22);
}

.modal-content button[type="submit"] {
  width: 100%;
  padding: 12px 18px;
  border-radius: 16px;
  border: none;
  background: linear-gradient(120deg, #2563eb, #4338ca);
  color: #ffffff;
  font-weight: 700;
  letter-spacing: 0.03em;
  cursor: pointer;
  box-shadow: 0 20px 38px rgba(37, 99, 235, 0.28);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.modal-content button[type="submit"]:hover {
  transform: translateY(-1px);
  box-shadow: 0 26px 46px rgba(37, 99, 235, 0.35);
}

.message-section {
  margin-top: 18px;
  padding: 18px 20px;
  border-radius: 18px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
  box-shadow: 0 18px 32px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.message-section h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #1f2937;
}

.message-section pre {
  margin: 0;
  padding: 14px 16px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid rgba(148, 163, 184, 0.35);
  font-size: 0.92rem;
  line-height: 1.6;
  color: #0f172a;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 260px;
  overflow: auto;
}

.message-section pre::-webkit-scrollbar {
  width: 8px;
}

.message-section pre::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.45);
  border-radius: 999px;
}

.message-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.message-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.4);
  background: #f1f5f9;
  color: #1f2937;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.message-actions button:hover {
  background: #e0e7ff;
  border-color: rgba(99, 102, 241, 0.5);
  color: #4338ca;
  transform: translateY(-1px);
}

.message-actions .copy-button {
  border: none;
  background: linear-gradient(120deg, #22c55e, #16a34a);
  color: #ffffff;
  box-shadow: 0 12px 28px rgba(34, 197, 94, 0.25);
}

.message-actions .copy-button:hover {
  box-shadow: 0 16px 36px rgba(34, 197, 94, 0.32);
}

.order-modal {
  width: min(360px, 92vw);
  padding: 30px 32px 34px;
  background: linear-gradient(160deg, #2f3543 0%, #1f262f 100%);
  border-radius: 26px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.45);
  color: #f8fafc;
  text-align: center;
}

.order-modal h2 {
  margin: 0 auto 20px;
  font-size: 1.45rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.order-loader,
.order-empty,
.order-error {
  font-size: 0.95rem;
  color: #e2e8f0;
  margin: 24px 0 0;
}

.order-error {
  color: #fca5a5;
}

.order-card {
  background: linear-gradient(165deg, #f8fafc 0%, #e5ebf6 100%);
  border-radius: 22px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.18);
  padding: 22px 24px;
  color: #0f172a;
}

.order-card__body {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.order-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
}

.order-field__label {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #4b5563;
}

.order-field__value {
  font-size: 1.02rem;
  font-weight: 700;
  color: #111827;
}

.order-field--products {
  border-top: 1px solid rgba(79, 70, 229, 0.16);
  padding-top: 16px;
  width: 100%;
}

.order-products {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  color: #1f2937;
  font-weight: 600;
}

.order-products li {
  padding: 6px 0;
  border-radius: 10px;
  text-align: center;
}

.order-product--green {
  color: #166534;
}

.order-product--orange {
  color: #9a3412;
}

.order-product--neutral {
  color: #1f2937;
}

@media (max-width: 1440px) {
  .table-scroll-hint {
    display: block;
  }

  .users-table-scroll {
    margin-top: 0;
  }
}

@media (max-width: 1024px) {
  .search-container {
    padding: 16px;
    gap: 12px;
  }
}

@media (max-width: 640px) {
  .search-container {
    flex-direction: column;
    align-items: stretch;
  }

  .search-container > button {
    width: 100%;
  }

  .search-field {
    min-width: 0;
    flex: 0 0 auto;
  }

  .users-table thead th:last-child,
  .users-table tbody td:last-child {
    position: static;
    box-shadow: none;
  }

  .modal-content {
    padding: 28px 22px;
  }

  .message-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .message-actions button,
  .message-actions .copy-button {
    width: 100%;
  }
}
</style>

<style scoped src="../../assets/css/staff-users-toolbar.css"></style>

<style scoped src="../../assets/css/staff-editor-dialog.css"></style>
<style scoped src="../../assets/css/staff-user-create-dialog.css"></style>
